import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Car, 
  MapPin, 
  Smartphone,
  Send,
  Map as MapIcon,
  Bell, 
  History,
  BarChart3,
  CreditCard,
  Radio,
  FileText,
  Settings,
  Users,
  LogOut,
  Menu,
  X
} from 'lucide-react';
import { useAuthStore, useUIStore } from '../store';
import { toast } from 'react-toastify';

const Sidebar = () => {
  const location = useLocation();
  const logout = useAuthStore((state) => state.logout);
  const user = useAuthStore((state) => state.user);
  const { sidebarOpen, toggleSidebar } = useUIStore();

  const menuItems = [
    { icon: LayoutDashboard, label: 'Dashboard', path: '/dashboard' },
    { icon: Car, label: 'Veiculos', path: '/vehicles' },
    { icon: MapPin, label: 'Rastreamento', path: '/tracking' },
    { icon: Smartphone, label: 'Celular', path: '/mobile-tracking' },
    { icon: Send, label: 'Comandos', path: '/commands' },
    { icon: MapIcon, label: 'Cercas', path: '/geofences' },
    { icon: Bell, label: 'Alertas', path: '/alerts' },
    { icon: History, label: 'Histórico', path: '/history' },
    ...(user?.role === 'admin' ? [
      { icon: BarChart3, label: 'Relatorios', path: '/reports' },
      { icon: CreditCard, label: 'Financeiro', path: '/billing' },
      { icon: Radio, label: 'Rastreadores', path: '/devices' },
      { icon: FileText, label: 'Clientes', path: '/clients' },
      { icon: Users, label: 'Usuarios', path: '/users' },
    ] : []),
    { icon: Settings, label: 'Configuracoes', path: '/settings' },
  ];

  const handleLogout = () => {
    logout();
    toast.success('Logout realizado com sucesso');
  };

  return (
    <>
      {/* Mobile Toggle Button */}
      <button
        onClick={toggleSidebar}
        className="lg:hidden fixed top-4 left-4 z-50 p-2 rounded-lg bg-dark-800 text-white"
      >
        {sidebarOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
      </button>

      {/* Overlay para mobile */}
      {sidebarOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-30"
          onClick={toggleSidebar}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`
          fixed lg:relative inset-y-0 left-0 z-40
          w-64 bg-[#07111f] border-r border-primary-300/15
          transform transition-transform duration-300 ease-in-out
          ${sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
        `}
      >
        <div className="flex flex-col h-full">
          {/* Logo */}
          <div className="p-6 border-b border-primary-300/15">
            <Link to="/tracking" className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-gradient-primary flex items-center justify-center shadow-lg shadow-primary-400/25">
                <Car className="w-6 h-6 text-white" />
              </div>
              <div>
                <h1 className="text-xl font-bold text-white">RCrastro</h1>
                <p className="text-xs text-primary-200/70">Rastreamento</p>
              </div>
            </Link>
          </div>

          {/* Menu */}
          <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;

              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`
                    flex items-center gap-3 px-4 py-3 rounded-lg
                    transition-all duration-200
                    ${isActive
                      ? 'bg-primary-500 text-white shadow-lg shadow-primary-500/25'
                      : 'text-slate-400 hover:bg-primary-500/10 hover:text-white'
                    }
                  `}
                  onClick={() => {
                    if (window.innerWidth < 1024) {
                      toggleSidebar();
                    }
                  }}
                >
                  <Icon className="w-5 h-5" />
                  <span className="font-medium">{item.label}</span>
                </Link>
              );
            })}
          </nav>

          {/* Logout Button */}
          <div className="p-4 border-t border-primary-300/15">
            <button
              onClick={handleLogout}
              className="flex items-center gap-3 w-full px-4 py-3 rounded-lg text-danger-400 hover:bg-dark-800 transition-all duration-200"
            >
              <LogOut className="w-5 h-5" />
              <span className="font-medium">Sair</span>
            </button>
          </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
